import React from 'react';
import EmptyPage from '../EmptyPage';

const QuoteCreatePage: React.FC = () => {
  return (
    <EmptyPage
      title="견적 생성"
      icon="Plus"
      description="새로운 번역/통역 견적을 생성합니다."
      parentTitle="견적"
    />
  );
};

export default QuoteCreatePage;
